import { useNavigate, Link, useLocation } from 'react-router-dom';
import { AccessContext } from '../components/context.js';
import { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faEnvelope, faMessage } from '@fortawesome/free-regular-svg-icons';
import { faLaptop, faGear, faMicrophoneAlt, faRectangleAd, faRectangleList, faTicket, faIdCard, faShirt, faCaretDown, faRightFromBracket, faRepeat } from '@fortawesome/free-solid-svg-icons';

const MobileMenu = () => {
    const {pathname} = useLocation();
    const [open, setOpen] = useState(false);
    const [openDD, setOpenDD] = useState([false, false, false, false, false]);
    const access = useContext(AccessContext);
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem('jwt');
        navigate('/login');
    }
    const toggleDD = (i) => {
        setOpenDD(dd => {
            var _dd = [...dd];
            _dd[i] = !_dd[i];
            return _dd;
        });
    }
    return (
        <>
            <button className="mobile-nav-open" onClick={() => setOpen(true)}>{'\u2630'}</button>
            <nav className={"f-col f-start pt-30 pb-30 pr-50 pl-50 flex gap-25 mobile-nav" + (open ? ' nav-open' : '')}>
                <button className="mobile-nav-close" onClick={() => setOpen(false)}>{'\u00D7'}</button>
                <Link className={pathname == '/' && 'active'} to="/">
                    <div className="flex a-start">
                        <FontAwesomeIcon icon={faLaptop} />
                        <span>Dashboard</span>
                    </div>
                </Link>
                <div className={"dropdown-container" + (openDD[0] ? ' active' : '')}>
                    <div className="flex w-100 a-start" role="button" onClick={() => toggleDD(0)}>
                        <FontAwesomeIcon icon={faMicrophoneAlt} />
                        <span>Episodes</span>
                        <FontAwesomeIcon icon={faCaretDown} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/episode-list' && 'active'} to="/episode-list">View All Episodes</Link>
                        <Link className={pathname == '/episode' && 'active'} to="/episode">Create Episode</Link>
                    </div>
                </div>
                <div className={"dropdown-container" + (openDD[1] ? ' active' : '')}>
                    <div className="flex w-100 a-start" role="button" onClick={() => toggleDD(1)}>
                        <FontAwesomeIcon icon={faIdCard} />
                        <span>Hosts & Guests</span>
                        <FontAwesomeIcon icon={faCaretDown} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/host-list' && 'active'} to="/host-list">View All Hosts</Link>
                        <Link className={pathname == '/guest-list' && 'active'} to="/guest-list">View All Guests</Link>
                    </div>
                </div>
                {access?.merch && <div className={"dropdown-container" + (openDD[3] ? ' active' : '')}>
                    <div className="flex w-100 a-start" role="button" onClick={() => toggleDD(3)}>
                        <FontAwesomeIcon icon={faShirt} />
                        <span>Merch & Products</span>
                        <FontAwesomeIcon icon={faCaretDown} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/merch-list' && 'active'} to="/sponsor-list">View All Merch</Link>
                        <Link className={pathname == '/merch' && 'active'} to="/sponsor">Create Merch</Link>
                    </div>
                </div>}
                {access?.events && <div className={"dropdown-container" + (openDD[4] ? ' active' : '')}>
                    <div className="flex w-100 a-start" role="button" onClick={() => toggleDD(4)}>
                        <FontAwesomeIcon icon={faTicket} />
                        <span>Events & Tickets</span>
                        <FontAwesomeIcon icon={faCaretDown} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/event-list' && 'active'} to="/sponsor-list">View All Events</Link>
                        <Link className={pathname == '/event' && 'active'} to="/sponsor">Create Event</Link>
                    </div>
                </div>}
                {access?.sponsors && <div className={"dropdown-container" + (openDD[2] ? ' active' : '')}>
                    <div className="flex w-100 a-start" role="button" onClick={() => toggleDD(2)}>
                        <FontAwesomeIcon icon={faRectangleAd} />
                        <span>Podcast Sponsors</span>
                        <FontAwesomeIcon icon={faCaretDown} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/sponsor-list' && 'active'} to="/sponsor-list">View All Sponsors</Link>
                        <Link className={pathname == '/sponsor' && 'active'} to="/sponsor">Create Sponsor</Link>
                    </div>
                </div>}
                <Link className={pathname == '/podcast-settings' && 'active'} to="/podcast-settings">
                    <div className="flex w-100 a-start">
                        <FontAwesomeIcon icon={faRectangleList} />
                        <span>Podcast Settings</span>
                    </div>
                </Link>
                <div className="flex w-100 f-center gap-10 mt-15">
                    <Link to="/" title="Notifications">
                        <FontAwesomeIcon icon={faBell} />
                    </Link>
                    <Link to="/" title="Emails">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </Link>
                    <Link to="/" title="Messages">
                        <FontAwesomeIcon icon={faMessage} />
                    </Link>
                    <Link to="/" title="Settings">
                        <FontAwesomeIcon icon={faGear} />
                    </Link>
                    {access?.role === 'Super' && (
                        <Link to="/protected/podcast-select" title="Change Podcast">
                            <FontAwesomeIcon icon={faRepeat} />
                        </Link>
                    )}
                    <a role="button" onClick={logout} title="Log Out">
                        <FontAwesomeIcon icon={faRightFromBracket} />
                    </a>
                </div>
            </nav>
        </>
    );
}

export default MobileMenu;